<!--
 * @Author: M.D.
 * @Date: 2019-12-31 14:02:18
 * @LastEditors  : M.D.
 * @Description:
 * @Remarks:
 -->
<template>
  <div class="prd-cate-w">
    <category-filter @filterInfo='getDataByFilter'></category-filter>
    <gds-list :outerFilter="headFilter"></gds-list>
  </div>
</template>

<script>
import CategoryFilter from '@/components/category-filter'
import GdsList from '@/components/gds-list'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {

  },
  data () {
    return {
      headFilter: {
        curLoc: this.curLoc
      }
    }
  },
  computed: {
    ...mapGetters(['searchTxt', 'curLoc'])
  },
  created () {

  },
  mounted () {

  },
  activated () {

  },
  deactivated () {

  },
  watch: {
    curLoc (v) {
      let f = this._.clone(this.headFilter)
      f.curLoc = v
      this.getDataByFilter(f)
    }
  },
  methods: {
    ...mapActions(['setSearchTxt', 'clearSearchTxt']),
    getDataByFilter (f) {
      if (!this._.isEmpty(f)) {
        this.headFilter = f
      }
    }
  },
  components: {
    CategoryFilter,GdsList
  }
  // beforeRouteEnter (from, to, next) {
  //   next(vm => {
  //     if (vm.$route.query.q) {
  //       vm.setSearchTxt(vm.$route.query.q)
  //     }
  //   })
  // },
  // beforeRouteLeave (from, to, next) {
  //   this.clearSearchTxt()
  //   next()
  // }
}
</script>

<style lang="stylus" scoped>
.prd-cate-w{
  width:1200px;
  margin: auto;
}
</style>
